// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';

import { withTranslation } from 'react-i18next';

import { withTheme, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const styles = theme => ({
  main: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  mainShift: {
    marginLeft: 270,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  mainShiftFr: {
    marginLeft: 300,
  }
});

type Props = {
  children: Object,
  classes: Object,
  i18n: Function,
  sidebar: boolean,
};

const Main = (props: Props) => {
  const { classes, sidebar, children, i18n } = props;
  return (
    <div
      className={classNames(classes.main, {
        [classes.mainShift]: sidebar,
        [classes.mainShiftFr]: sidebar && i18n.language === 'fr'
      })}
    >
      {children}
    </div>
  );
};

Main.propTypes = {
  // eslint-disable-next-line
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(
  withStyles(styles, { withTheme: true })(
    withRouter(withTheme(Main))));
